/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationEnrollmentGridQueryResponse,
  GetApiV1CourseregistrationEnrollmentGridQueryParams,
  GetApiV1CourseregistrationEnrollmentGrid401,
  GetApiV1CourseregistrationEnrollmentGrid500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentGrid.ts";

function getGetApiV1CourseregistrationEnrollmentGridUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/enrollment/grid` as const,
  };
  return res;
}

/**
 * @description Retorna matrículas agrupadas por curso, polo e turma com suporte a filtros de empresa, polo, status, documentação, aluno, e-mail e CPF. O campo TotalPeopleCount indica o total de pessoas distintas no resultado filtrado (antes da paginação). Os children de cada grupo são carregados sob demanda via GET enrollment/grid/children. **(Requer Authorization para autenticação)**
 * @summary Lista matrículas paginadas com filtros (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/grid}
 */
export async function getApiV1CourseregistrationEnrollmentGrid(
  params?: GetApiV1CourseregistrationEnrollmentGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationEnrollmentGridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentGrid401
      | GetApiV1CourseregistrationEnrollmentGrid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationEnrollmentGridUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
